export const UNLIMITED_INSPECTION_QUOTA = 100000000;
export const MAX_COLLABORATOR_INSPECTION_QUOTA = 20;
export const DEFAULT_INSPECTION_QUOTA_BASE_LIMIT = 3;
export const MAX_ADDITIONAL_ORG_INSPECTION_QUOTA = 100;
